import React from 'react';
import InfoIcon from '@assets/icons/tooltip-icon.svg';
import { BaseTooltip } from '@components';
import { useLingui } from '@lingui/react/macro';
import { TooltipContent } from '@routes/___shared___/styled.tsx';
import { TabContent } from '@routes/profile-bar/___pages___/my-profile/styled.tsx';
import { TabContentInfoWrapper } from '@routes/profile-bar/___shared___/styled.tsx';

import MyImportedLearningsTable from './tables/my-imported-learnings';
import { TabHeaderWithTooltip } from './tables/my-imported-learnings/styled.tsx';

const MyImportedLearningsTab: React.FC = () => {
    const { t } = useLingui();

    return (
        <TabContent>
            <TabContentInfoWrapper>
                <TabHeaderWithTooltip>
                    {t`My Imported Learnings`}
                    <BaseTooltip
                        title={
                            <TooltipContent>
                                {t`Historical results imported from previous systems. Shown for reference and kept separate from BlueByte-generated results.`}
                            </TooltipContent>
                        }
                        placement="right"
                        arrow={false}
                        icon={<InfoIcon />}
                    />
                </TabHeaderWithTooltip>
            </TabContentInfoWrapper>
            <MyImportedLearningsTable />
        </TabContent>
    );
};

export default MyImportedLearningsTab;
